// extracted by mini-css-extract-plugin
export default {"works":"works-list_works__+DpRd","worksList":"works-list_worksList__RxT9Y","skills":"works-list_skills__eMh5v"};